import React, { useEffect, useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import IntlMessages from "@util/IntlMessages";
import { getList } from "services/api/Api";
import "./levelStatus.less";
import LevelStatusSettings from "../WidgetsSettings/LevelStatus/LevelStatusSettingsModal";
import { parseFile } from "../../ParseFile/ParseFile";
import { isActivePublicUser } from "../../../util/Scripts";

const LevelStatus = ({ value, role }) => {
   const [columns, setColumns] = useState([]);
   const [columnsPoints, setColumnsPoints] = useState([]);
   const [level, setLevel] = useState();
   const [points, setPoints] = useState();
   const [id, setId] = useState();

   useEffect(() => {
      const levelCopy = [];
      if (value.listId && value.listIdForPoints) {
         getList(value.listIdForPoints, 1, 10).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            setColumnsPoints(responseData.columns);
            responseData.data.map((row) => {
               setPoints(row[value.columnToDisplayPoints].value);
               getList(value.listId, 1, 10).then((response) => {
                  setColumns(responseData.columns);
                  responseData.data.map((rowSecond) => {
                     if (rowSecond.Nazwa == row[value.columnToDisplayPoints].value) {
                        const copyParsedId = parseFile(
                           rowSecond[value.columnToDisplayPhoto]?.altUrl ??
                           rowSecond[value.columnToDisplayPhoto]?.altUrl1 ??
                              rowSecond[value.columnToDisplayPhoto]?.fileUrl
                        );
                        setId(copyParsedId);
                     }

                     levelCopy.push(rowSecond[value.columnToDisplayLevel]);
                  });
                  setLevel(levelCopy);
               });
            });
         });
      }
   }, [value]);
   return (
      <div className="summaryWidgetHopps">
         <Widget
            style={{ height: "180px" }}
            styleName="gx-mt-3"
            bgColor={value.backgroundColourHex}
            className="summaryWidget"
            role={role}
            extra={
               role === "OWNER" || role === "MODERATOR" ? (
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={
                        <LevelStatusSettings
                           value={value}
                           columns={columns}
                           columnsPoints={columnsPoints}
                        />
                     }
                  />
               ) : null
            }
         >
            <p>
               {value ? (
                  <div
                     style={{
                        display: "flex",
                        justifyContent: "spaceEvenly"
                     }}
                  >
                     {id ? (
                        <img
                           alt="beer"
                           src={`https://drive.google.com/thumbnail?authuser=0&id=${id}&sz=h${180}`}
                           className="image-beer"
                        />
                     ) : (
                        ""
                     )}
                     <div className="ranges">
                        {level &&
                           level.map((level) => (
                              <div
                                 style={{
                                    marginLeft: "50px",
                                    display: "flex",
                                    marginBottom: "20px"
                                 }}
                              >
                                 <div className="container">
                                    <div className="circle"></div>
                                 </div>
                                 <p className={`${level == points ? "text-cp" : "text-grey"}`}>
                                    {level}
                                 </p>
                              </div>
                           ))}
                     </div>
                  </div>
               ) : (
                  <p className="gx-pl-3">
                     <IntlMessages id="timeline.selectListIdAndAttributes" />
                  </p>
               )}
            </p>
         </Widget>
      </div>
   );
};

export default LevelStatus;
